import React from 'react'
import * as Yup from "yup";

const formView = (defaultValues, value) => [
  {
    name: 'id',
    type: 'Hidden',
  },
  {
    name: 'laser_properties_id',
    type: 'Hidden',
  },
  {
    label: 'Add New Laser Profile',
    hint: 'Create a new laser profile to customize laser parameters for specific products.',
    type: 'Header',
    labelClassName: 'hidden',
    className: 'col-span-12',
    condition: (value) => !value?.id,
  },
  {
    name: 'divider',
    type: 'Divider',
    className: 'col-span-12',
    condition: (value) => !value?.id,
  },
  {
    label: '',
    hint: (
      <div className={'flex flex-col bg-yellow-50 rounded-md p-md mb-md text-yellow-700 relative gap-sm'}>
        <span className={'text-title-md'}>Please note:</span>Updating this hatch profile will affect all products that
        use this pattern. Proceed with caution.
      </div>
    ),
    headerClassName: 'hidden',
    hintClassName: '',
    type: 'Header',
    labelClassName: 'hidden',
    className: 'col-span-12',
    condition: (value) => value?.id,
  },

  {
    name: 'name',
    label: 'Name',
    placeholder: 'Enter laser profile name',
    type: 'Input',
    className: 'col-span-12',
	validation: Yup.string().matches(/^[^`~!@#$%^&*;:'",.?\\()[\]{}<>+=|=-]+$/, 'Invalid characters'),
    clear: false,
    reset: false,
  },
  {
    name: 'description',
    label: 'Description',
    placeholder: 'Enter description',
    type: 'Input',
    className: 'col-span-12',
    clear: false,
    reset: false,
  },
  {
    type: 'Divider',
    className: 'col-span-12',
  },
  {
    name: 'wobble_overlap_percentage',
    label: labelGenerator('Wobble Overlap Percentage', '%'),
    placeholder: 'Overlap',
    type: 'NumberSlider',
    min: 0,
    max: 100,
    className: 'col-span-12',
    clear: false,
    reset: false,
    labelClassName: 'w-[300px]',
    defaultValue: '80.0',
  },
  {
    name: 'wobble_thickness',
    label: labelGenerator('Wobble Thickness', 'mm'),
    placeholder: 'Thickness',
    type: 'Number',
    className: 'col-span-6',
    clear: false,
    reset: false,
    labelClassName: 'w-[300px]',
    defaultValue: '0.0',
  },
  {
    type: 'Divider',
    className: 'col-span-12',
  },
  {
    name: 'power',
    label: labelGenerator('Power', '%'),
    placeholder: 'Power',
    type: 'Number',
    className: 'col-span-6',
    defaultValue: defaultValues?.power || '45.0',
    clear: false,
    reset: false,
  },
  {
    type: 'Header',
    className: 'col-span-8',
  },
  {
    name: 'jump_speed',
    label: labelGenerator('Jump Speed', 'mm/s'),
    placeholder: 'Speed',
    type: 'Number',
    className: 'col-span-6',
    clear: false,
    reset: false,
    defaultValue: '6000.0',
  },
  {
    name: 'jump_delay',
    label: labelGenerator('Jump Delay', 'µs'),
    placeholder: 'Delay',
    type: 'Number',
    className: 'col-span-6',
    clear: false,
    reset: false,
    defaultValue: '400',
  },

  {
    name: 'marking_speed',
    label: labelGenerator('Marking Speed', 'mm/s'),
    placeholder: 'Speed',
    type: 'Number',
    className: 'col-span-6',
    labelClassName: 'w-[300px]',
    clear: false,
    reset: false,
    defaultValue: '6000.0',
  },
  {
    name: 'mark_delay',
    label: labelGenerator('Mark Delay', 'µs'),
    placeholder: 'Delay',
    type: 'Number',
    className: 'col-span-6',
    clear: false,
    reset: false,
    defaultValue: '400',
  },

  {
    name: 'laser_on_delay',
    label: labelGenerator('Laser On Delay', 'µs'),
    placeholder: 'Delay',
    type: 'Number',
    className: 'col-span-6',
    labelClassName: 'w-[300px]',
    clear: false,
    reset: false,
    defaultValue: '60',
  },
  {
    name: 'laser_off_delay',
    label: labelGenerator('Laser Off Delay', 'µs'),
    placeholder: 'Delay',
    type: 'Number',
    className: 'col-span-6',
    labelClassName: 'w-[300px]',
    clear: false,
    reset: false,
    defaultValue: '60',
  },

  {
    name: 'poly_delay',
    label: labelGenerator('Poly Delay', 'µs'),
    placeholder: 'Delay',
    type: 'Number',
    className: 'col-span-6',
    clear: false,
    reset: false,
    defaultValue: '0',
  },
  {
    name: 'pipeline_delay',
    label: labelGenerator('Pipeline Delay', 'µs'),
    placeholder: 'Delay',
    type: 'Number',
    className: 'col-span-6',
    labelClassName: 'w-[300px]',
    clear: false,
    reset: false,
    defaultValue: '400',
  },

  {
    name: 'modulation_frequency',
    label: labelGenerator('Modulation Frequency', 'kHz'),
    placeholder: 'Frequency',
    type: 'Number',
    className: 'col-span-6',
    labelClassName: 'w-[300px]',
    clear: false,
    reset: false,
    defaultValue: '15.0',
  },

  /*{
        name: "duty_cycle_one",
        label: "Duty Cycle One",
        placeholder: "Cycle One",
        type: "Number",
        className: "col-span-6",
        labelClassName: "w-[300px]",
        clear: false,
        reset: false,
    },
    {
        name: "duty_cycle_two",
        label: "Duty Cycle Two",
        placeholder: "Cycle Two",
        type: "Number",
        className: "col-span-6",
        labelClassName: "w-[300px]",
        clear: false,
        reset: false,
    },*/
  /*{
        type: "Header",
        className: "col-span-6",
    },*/

  {
    name: 'repeat_count',
    label: 'Repeat Count',
    placeholder: 'Count',
    type: 'Number',
    className: 'col-span-6',
    labelClassName: 'w-[300px]',
    clear: false,
    reset: false,
    defaultValue: '1',
  },

  {
    name: 'pulse_waveform',
    label: 'Pulse Waveform',
    placeholder: 'Count',
    type: 'Hidden',
    className: 'col-span-6',
    labelClassName: 'w-[300px]',
    defaultValue: '0',
    clear: false,
    reset: false,
  },

  {
    type: 'Divider',
    className: 'col-span-12',
  },
  {
    type: 'Header',
    label: 'Velocity Compensation',
    labelClassName: 'hidden',
    className: 'col-span-12',
  },
  {
    name: 'velocity_compensation_mode',
    label: 'Mode',
    placeholder: 'Mode',
    type: 'Select',
    list: [
      { label: 'Enabled', value: 'enabled' },
      { label: 'Disabled', value: 'disabled' },
    ],
    className: 'col-span-6',
    labelClassName: 'w-[300px]',
    clear: false,
    reset: false,
    menuPortalTarget: 'false',
    defaultValue: 'disabled',
  },
  {
    name: 'velocity_compensation_limit',
    label: labelGenerator('Limit', '%'),
    placeholder: 'Limit',
    type: 'Number',
    className: 'col-span-6',
    labelClassName: 'w-[300px]',
    clear: false,
    reset: false,
    defaultValue: '50.0',
    condition: (value) => value?.velocity_compensation_mode === 'enabled',
    saveData: true,
  },
  {
    name: 'velocity_compensation_aggressiveness',
    label: 'Aggressiveness',
    placeholder: 'Count',
    type: 'Number',
    className: 'col-span-6',
    labelClassName: 'w-[300px]',
    clear: false,
    reset: false,
    defaultValue: '1200.0',
    condition: (value) => value?.velocity_compensation_mode === 'enabled',
    saveData: true,
  },
  {
    type: 'Divider',
    className: 'col-span-12',
  },
  {
    name: 'max_radial_error',
    label: labelGenerator('Max Radial Error', 'mm'),
    placeholder: 'Max error',
    type: 'Number',
    className: 'col-span-6',
    labelClassName: 'w-[300px]',
    clear: false,
    reset: false,
    defaultValue: '0.1',
  },
  {
    name: 'break_angle',
    label: 'Break Angle',
    placeholder: 'Count',
    type: 'Number',
    className: 'col-span-6',
    labelClassName: 'w-[300px]',
    clear: false,
    reset: false,
    defaultValue: '0.7853982',
  },
]

const labelGenerator = (text, unit) => {
  return (
    <div className={'flex flex-row items-center gap-sm'}>
      <span>{text}</span>
      <span className={'text-gray-400 text-sm'}>({unit})</span>
    </div>
  )
}

export default formView
